<template>
    <modal-base :pacifier="false">
        <template #title>
            You've Been Successfully Matched<br>
            with an Unbundled Lawyer
        </template>

        <template #extra>
            <div class="text-center text-lg md:text-xl mt-4">
                Current Status:
                <span v-if="isBusinessHours" class="text-green-600 ml-4"><i class="fas fa-check mr-1"></i>Online</span>
                <span v-if="! isBusinessHours" class="text-red-500 ml-4"><i class="text-lg far fa-clock mr-1"></i>Offline</span>
            </div>

            <div v-if="isBusinessHours" class="text-center font-bold text-md md:text-lg mt-6">
                Select Your Next Step Below:
            </div>

            <div v-if="! canInitiateCall && hasCalendly" class="text-center font-bold text-md md:text-lg mt-6">
                Please schedule an appointment using the link below:
            </div>

            <div class="mt-4 text-center">
                <div class="inline-flex flex-col">

                    <button class="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded border-none"
                        type="submit"
                        @click="call"
                        v-if="canInitiateCall">
                        <i class="fas fa-phone-alt mr-1"></i>

                        Call and Connect Me Now
                    </button>

                    <button v-if="hasCalendly" class="bg-blue-500 hover:bg-blue-700 text-white font-bold mt-2 py-2 px-4 rounded border-none"
                        type="submit"
                        @click="schedule">
                        <i class="fas fa-calendar-alt mr-1"></i>

                        {{ scheduleButtonText }}
                    </button>

                    <div v-if="isBusinessHours" class="text-center font-bold text-md md:text-lg mt-6">
                        Or We Will Call You from {{ directConnectFrom }} in {{ directConnectFirstCallDelay }} sec.
                    </div>
                </div>
            </div>
        </template>
    </modal-base>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        mounted() {
            if (this.isUnactionable) {
                this.$event.$emit('close-modal');
            }

            this.$store.commit('card', 'contact');
        },

        computed: {

            scheduleButtonText() {
                return this.hasScheduledCall
                    ? 'Reschedule Your Appointment'
                    : 'Schedule an Appointment for Later';
            },

            ...mapGetters([
                'hasCalendly',
                'hasScheduledCall',
                'directConnectFrom',
                'directConnectFirstCallDelay',
                'leadHash',
                'tenant',
                'isBusinessHours',
                'canInitiateCall',
                'isUnactionable',
            ])
        },

        methods: {
            call() {
                this.$event.$emit('start-call');
            },

            schedule() {
                this.$store.commit('modal', 'schedule-appointment');
            },
        },
    }
</script>
